import type { ColumnsType } from 'antd/es/table';
import { Checkbox, Tooltip } from 'antd';

const ROLE_TOOLTIP_MESSAGE = "관리 권한이 없습니다";

type RoleType = 'TOTAL';
// type RoleType = 'READ' | 'WRITE' | 'DELETE';

export interface UserRoleData {
    userId: number;
    username: string;
    name: string;
    role: string;
    currentRoles: RoleType[];
    updatedRoles?: RoleType[];
    [key: string]: any;
}

export const getBoardRoleColumns = ({handleRoleChange, changedUsers}:
    { handleRoleChange: (userId: number, role: RoleType, checked: boolean) => void, changedUsers: Set<number> }
): ColumnsType<UserRoleData> => [
    {
        title: 'ID',
        dataIndex: 'username',
        key: 'username',
        width: 150,
        render: (text: string, record: UserRoleData) => (
            <span style={{ color: record.role !== 'ADVISOR' ? '#bfbfbf' : 'inherit' }}>
                {text}
            </span>
        ),
    },
    {
        title: '이름',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        render: (text: string, record: UserRoleData) => (
            <span style={{ color: record.role !== 'ADVISOR' ? '#bfbfbf' : 'inherit' }}>
                {text}
            </span>
        ),
    },
    {
        title: '접근 권한',
        key: 'read',
        align: 'center',
        width: 100,
        render: (_, record: UserRoleData) => {
            const roles = record.updatedRoles || record.currentRoles;
            
            const isPathologist = record.role === 'ADVISOR';
            const checkbox = (
                <Checkbox
                    checked={roles.includes('TOTAL')}
                    disabled={!isPathologist}
                    onChange={(e) => handleRoleChange(record.userId, 'TOTAL', e.target.checked)}
                />
            );

            return !isPathologist ? (
                <Tooltip placement="bottom" title={ROLE_TOOLTIP_MESSAGE}>
                    {checkbox}
                </Tooltip>
            ) : checkbox;
        },
    },
    // {
    //     title: 'WRITE',
    //     key: 'write',
    //     align: 'center',
    //     width: 100,
    //     render: (_, record: UserRoleData) => {
    //         const roles = record.updatedRoles || record.currentRoles;
    //         const isPathologist = record.role === 'ADVISOR';
    //         const checkbox = (
    //             <Checkbox
    //                 checked={roles.includes('WRITE')}
    //                 disabled={!isPathologist}
    //                 onChange={(e) => handleRoleChange(record.userId, 'WRITE', e.target.checked)}
    //             />
    //         );

    //         return !isPathologist ? (
    //             <Tooltip placement="bottom" title={ROLE_TOOLTIP_MESSAGE}>
    //                 {checkbox}
    //             </Tooltip>
    //         ) : checkbox;
    //     },
    // },
    // {
    //     title: 'DELETE',
    //     key: 'delete',
    //     align: 'center',
    //     width: 100,
    //     render: (_, record: UserRoleData) => {
    //         const roles = record.updatedRoles || record.currentRoles;
    //         const isPathologist = record.role === 'ADVISOR';
    //         const checkbox = (
    //             <Checkbox
    //                 checked={roles.includes('DELETE')}
    //                 disabled={!isPathologist}
    //                 onChange={(e) => handleRoleChange(record.userId, 'DELETE', e.target.checked)}
    //             />
    //         );

    //         return !isPathologist ? (
    //             <Tooltip placement="bottom" title={ROLE_TOOLTIP_MESSAGE}>
    //                 {checkbox}
    //             </Tooltip>
    //         ) : checkbox;
    //     },
    // },
    {
        title: '상태',
        key: 'status',
        align: 'center',
        width: 80,
        render: (_, record: UserRoleData) => (
            changedUsers.has(record.userId) ? (
                <span style={{ color: '#1890ff' }}>변경됨</span>
            ) : null
        ),
    },
];
